import React from 'react';

const THEME_COLORS = {
  wisdom:    { bg: '#EAF3DE', text: '#27500A' },
  family:    { bg: '#EAF3DE', text: '#27500A' },
  love:      { bg: '#FBEAF0', text: '#4B1528' },
  career:    { bg: '#E6F1FB', text: '#0C447C' },
  challenge: { bg: '#FAEEDA', text: '#412402' },
  identity:  { bg: '#FAEEDA', text: '#412402' },
  memory:    { bg: '#F1EFE8', text: '#2C2C2A' },
  humor:     { bg: '#F1EFE8', text: '#2C2C2A' },
};

const AVATAR_COLORS = ['#556B2F', '#7a3010', '#1a3a6a', '#4a1a6a', '#2a4a2a', '#6a1a2a'];
const avatarColor = (name) =>
  AVATAR_COLORS[name ? name.charCodeAt(0) % AVATAR_COLORS.length : 0];

const WisdomMomentCard = ({ moment }) => (
  <div style={{
    background: 'white',
    border: '0.5px solid #ddd',
    borderRadius: '10px',
    padding: '12px 14px',
  }}>
    {/* Person row */}
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
      <div style={{
        width: '28px', height: '28px', borderRadius: '50%',
        background: avatarColor(moment.person_name),
        color: 'white', fontSize: '11px', fontWeight: '600',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        flexShrink: 0,
      }}>
        {moment.person_name ? moment.person_name.charAt(0).toUpperCase() : '?'}
      </div>
      <div>
        <div style={{ fontSize: '13px', fontWeight: '500', color: '#2a2a1a', lineHeight: 1.2 }}>
          {moment.person_name}
        </div>
      </div>
    </div>

    {/* Quote */}
    <p style={{
      fontSize: '13px', color: '#444',
      fontStyle: 'italic', lineHeight: '1.6',
      margin: '0 0 8px 0',
    }}>
      &ldquo;{moment.text}&rdquo;
    </p>

    {/* Footer */}
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <span style={{
        fontSize: '10px', fontWeight: '600',
        padding: '2px 7px', borderRadius: '20px',
        background: THEME_COLORS[moment.theme]?.bg || '#F1EFE8',
        color: THEME_COLORS[moment.theme]?.text || '#2C2C2A',
        textTransform: 'capitalize',
      }}>
        {moment.theme}
      </span>
      <span style={{ fontSize: '10px', color: '#aaa' }}>
        {moment.source_video_id ? 'from video' : ''}
      </span>
    </div>
  </div>
);

export default WisdomMomentCard;
